/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 11:18:56
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-23 14:21:40
 * @Description: 活动微信授权
 * 自定义Vue.prototype:
 * $channel   渠道
 * $fopenid   上级传播者openid
 * $userInfo  用户信息
 * $openid    用户openid
 * $appid     用户openid对应的微信公众号appid
 */
import Vue from "vue/dist/vue.js";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import request from "@/http/common";
import util from "@/utils/common";
import servicesActWxjssdk from "@/services/act-wxjssdk";
// import servicesRushiH5jssdk from '@/services/rushi-h5-jssdk';
import apiActWxauth from "@/api/act-wxauth";
// import apiActLogicPlatform from "@/api/act-logic-platform";

import apizt from "@/api/act-logic-zouteng";
import httpzt from "@/http/act-logic-zouteng";

let isInitWx = false;


const templateList = {
  '8c393519f5684a80b2d4a52e1e809e3c': 'assistanceHelp',
  'b32775b181ec48eb9e5afdea08ea6437': 'lightup',//
  '3e01bd24eac943ad892bd7d83d937055': 'haggle',//
}

// let isInitRushiH5 = false;
export default class MyRouter {
  constructor(options) {
    this.options = options;
    console.log("@/routers/wxauth-act.js options", this.options);
    this.router = new VueRouter({
      routes: [],
    });

    /**
     * 注册一个全局前置守卫
     * 
     * 当一个导航触发时，全局前置守卫按照创建顺序调用。守卫是异步解析执行，此时导航在所有守卫 resolve 完之前一直处于 等待中。
    
    每个守卫方法接收三个参数：
    to: Route: 即将要进入的目标 路由对象
    from: Route: 当前导航正要离开的路由
    next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
    next(): 进行管道中的下一个钩子。如果全部钩子执行完了，则导航的状态就是 confirmed (确认的)。
    next(false): 中断当前的导航。如果浏览器的 URL 改变了 (可能是用户手动或者浏览器后退按钮)，那么 URL 地址会重置到 from 路由对应的地址。
    next('/') 或者 next({ path: '/' }): 跳转到一个不同的地址。当前的导航被中断，然后进行一个新的导航。你可以向 next 传递任意位置对象，且允许设置诸如 replace: true、name: 'home' 之类的选项以及任何用在 router-link 的 to prop 或 router.push 中的选项。
    next(error): (2.4.0+) 如果传入 next 的参数是一个 Error 实例，则导航会被终止且该错误会被传递给 router.onError() 注册过的回调。
    确保要调用 next 方法，否则钩子就不会被 resolved。
     */
    this.router.beforeEach(async (to, from, next) => {
      // 设置页面title
      if (to.meta.title) {
        document.title = to.meta.title;
      }
      // 初始化cookies，是否有fake
      this.initCookies(to);
      // 初始化传播信息
      if (to.query && to.query.channel) {
        Vue.prototype.$channel = to.query.channel;
      } else {
        if (!Vue.prototype.$channel) {
          Vue.prototype.$channel = 1;
        }
      }
      if (to.query && to.query.fopenid) {
        Vue.prototype.$fopenid = to.query.fopenid;
      } else {
        if (!Vue.prototype.$fopenid) {
          Vue.prototype.$fopenid = "";
        }
      }

      if (to.query && to.query.avoidWeChatBug) {
        Vue.prototype.$avoidWeChatBug = to.query.avoidWeChatBug;
      } else {
        Vue.prototype.$avoidWeChatBug = "";
      }

      if (to.query && to.query.fromSaleOpenId) {
        Vue.prototype.$fromSaleOpenId = to.query.fromSaleOpenId;
      } else {
        if (!Vue.prototype.$fromSaleOpenId) {
          Vue.prototype.$fromSaleOpenId = "";
        }
      }

      if (to.query && to.query.refereeopenid) {
        Vue.prototype.$fopenid = to.query.refereeopenid;
      } else {
        if (!Vue.prototype.$fopenid) {
          Vue.prototype.$fopenid = "";
        }
      }
      if (to.query && to.query.intermediary) {
        Vue.prototype.$intermediary = to.query.intermediary;
      } else {
        if (!Vue.prototype.$intermediary) {
          Vue.prototype.$intermediary = "";
        }
      }

      if (to.query && to.query.actCode) {
        Vue.prototype.$actCode = to.query.actCode;
        util.cookie.set("actCode", to.query.actCode, { expires: 30 });
      } else {
        if (util.cookie.get("actCode")) {
          Vue.prototype.$actCode = util.cookie.get("actCode");
        } else if (!Vue.prototype.$actCode) {
          Vue.prototype.$actCode = "";
        }
      }

      // 获取企微授权的errorCode
      if (to.query && to.query.errorCode) {
        Vue.prototype.$errorCode = to.query.errorCode;
      }

      // 获取活动配置信息 有coprid 就走企微授权
      if (to.query && to.query.actCode) {
        // util.cookie.get("configInfo")
        await this.initActInfo().then((res) => {
          console.log(res, 'res')
          const cookieConfig = { ...res, actRule: "" };
          if (res.bizType == 4 || res.bizType == 3) {
            localStorage.setItem("corpid", res.corpId);
            util.cookie.set("corpid", res.corpId, {
              expires: 30,
            });
            Vue.prototype.$corpid = res.corpId;
          } else if (res.wxWorkSwitch == 1) {
            localStorage.setItem("corpid", res.corpid);
            util.cookie.set("corpid", res.corpid, {
              expires: 30,
            });
            Vue.prototype.$corpid = res.corpid;
          }
          Vue.prototype.$configInfo = res;
          localStorage.setItem("configInfo", JSON.stringify(cookieConfig));
          util.cookie.set("configInfo", JSON.stringify(cookieConfig), {
            expires: 30,
          });
        });
      } else {
        if (util.cookie.get("configInfo")) {
          Vue.prototype.$configInfo = JSON.parse(util.cookie.get("configInfo"));
        } else if (!Vue.prototype.$configInfo) {
          Vue.prototype.$configInfo = "";
        }
      }


      // 获取企微用户授权之后的appinfo
      if (to.query && to.query.appInfo) {
        const { corpId, userId } = JSON.parse(to.query.appInfo);
        if (corpId) {
          Vue.prototype.$corpId = corpId;
          util.cookie.set("corpId", corpId, { expires: 30 });
        }
        if (userId) {
          Vue.prototype.$userId = userId;
          util.cookie.set("userId", userId, { expires: 30 });
        }
        Vue.prototype.$userId = userId;
        util.cookie.set("userId", userId, { expires: 30 });
      } else {
        Vue.prototype.$corpId = "";
        Vue.prototype.$userId = "";
      }

      if (to.query && to.query.fcorpId) {
        Vue.prototype.$fcorpId = to.query.fcorpId;
        util.cookie.set("fcorpId", to.query.fcorpId, { expires: 30 });
      } else {
        Vue.prototype.$fcorpId = "";
      }
      if (to.query && to.query.fuserId) {
        Vue.prototype.$fuserId = to.query.fuserId;
        util.cookie.set("fuserId", to.query.fuserId, { expires: 30 });
      } else {
        Vue.prototype.$fuserId = "";
      }

      if (to.query?.isSnapshotUser == 1) {
        Vue.prototype.$isSnapshotUser = 1;
      } else {
        Vue.prototype.$isSnapshotUser = "";
      }
      // 判断授权方式
      if (to.meta.requiresAuth === 0 || to.query?.isSnapshotUser == 1) {
        // 不授权
        next();
      } else {

        const configInfo = Vue.prototype.$configInfo;
        console.log(configInfo);

        if (process.env.VUE_APP_SERVE_ENV == 'prod' && to.name != 'writeoff') {
          if (window.location.pathname.indexOf(templateList[configInfo.templateCode]) == -1) {
            alert("非法活动链接!");
            return
          }
        }
        // if(configInfo.bizType==1||configInfo.bizType==4){
        //   if(configInfo.appId!=apiActWxauth.appid){
        //     alert("非法活动链接!");
        //     return 
        //   }
        // }
        // 线索管家的活动 兼容嵌套小程序活动
        if (to.query && to.query.actOpenId && to.query.actAppId) {
          util.cookie.set("actOpenId", to.query.actOpenId, { expires: 30 });
          util.cookie.set("actAppId", to.query.actAppId, { expires: 30 });
          apiActWxauth.appid = to.query.actAppId
          Vue.prototype.$appId = to.query.actAppId;
        } else {
          let actAppId = util.cookie.get("actAppId");
          if (actAppId != apiActWxauth.appid) {
            util.cookie.remove("actAppId");
            util.cookie.remove("actOpenId");
          }
        }

        console.log(this.isWxWork(), Vue.prototype.$corpid)
        if (this.isWxWork() && (Vue.prototype.$corpid || configInfo.corpId)) {
          this.wxWorkAuth(to).then((res) => {
            console.log(res);
            next();
          });
        } else {
          this.wxAuth(to).then((res) => {
            console.log(res);
            next();
          });
        }
      }
    });
    this.router.afterEach(() => {
      console.log("afterEach");
      // if (!isInitRushiH5 && Vue.prototype.$permission) {
      //   isInitRushiH5 = true;
      //   servicesRushiH5jssdk.init({
      //     openid: Vue.prototype.$openid,
      //     refereeopenid: Vue.prototype.$fopenid,
      //     channelid: Vue.prototype.$channel,
      //     infoid:Vue.prototype.$infoId,
      //     permission: Vue.prototype.$permission,
      //     rscuid:Vue.prototype.$rscuid,
      //   })
      // }

      if (!isInitWx) {
        isInitWx = true;
        servicesActWxjssdk.init(this.options.servicesActWxjssdk);
      }
      window.scrollTo(0, 0);
    });
  }

  initCookies(to) {
    if (to.query.cmd && to.query.cmd === "clean") {
      let cookieList = window.document.cookie.match(/[^ =;]+(?==)/g);
      if (cookieList && cookieList.length > 0) {
        cookieList.forEach((name) => {
          util.cookie.remove(name);
        });
      }
      let url = `${window.location.protocol}//${window.location.host}${window.location.pathname}#${to.path}`;
      window.location.replace(url);
    } else if (to.query.fake) {
      if (this.options.fake) {
        if (this.options.fake[to.query.fake]) {
          Object.getOwnPropertyNames(this.options.fake[to.query.fake]).forEach((name) => {
            util.cookie.set(name, this.options.fake[to.query.fake][name], {
              expires: 30, //天
            });
          });
        } else {
          alert(`本项目目录router未配置名为${to.query.fake}的fake`);
        }
      } else {
        alert("本项目目录router未配置fake");
      }
    } else {
      //拼完整的非hash url，用来取参数
      // const targetUrl = new URL(window.location.origin + "/?" + window.location.href.split("?")[1]);
      const targetUrl = new URL(window.location.origin + "/?" + window.location.href.split("?")[1]);
      const urlParams = [...targetUrl.searchParams].reduce((cur, [key, value]) => ((cur[key] = value), cur), {});
      //let appId = sessionStorage.getItem("actAppId");
      //let openId = sessionStorage.getItem("actOpenId");
      let openId = urlParams.openId;
      //if (appId && openId) {
      if (openId) {
        util.cookie.set('actAppId', apiActWxauth.appid, { expires: 30 });
        util.cookie.set("actOpenId", openId, { expires: 30 });
      }
    }
  }

  checkAuthCanUse() {
    let actOpenId = util.cookie.get("actOpenId");
    let actAppId = util.cookie.get("actAppId");
    let corpId = util.cookie.get("corpId");
    let userId = util.cookie.get("userId");
    console.log(corpId, userId);
    if ((actOpenId && actAppId) || (corpId && userId && this.isWxWork())) {
      apiActWxauth.openid = actOpenId;
      Vue.prototype.$openid = actOpenId;
      Vue.prototype.$appid = actAppId;
      Vue.prototype.$corpId = corpId;
      Vue.prototype.$userId = userId;
      return true;
    } else {
      return false;
    }
  }

  getAuthUrl(to) {
    return new Promise((resolve, reject) => {
      // 获取授权链接
      let query = {
        htmlUrl: location.href,
        appId: apiActWxauth.appid,
      };
      //在获取微信OAuth2.0授权之前，将活动的appid写入缓存
      if (query.appId) {
        util.cookie.set("actAppId", query.appId, { expires: 30 });
      }
      //let url = `${apiActWxauth.protocol}//${apiActWxauth.appid}.${apiActWxauth.domain}${apiActWxauth.action.auth}/${to.meta.requiresAuth}?${request.qs.stringify(query)}`;
      let url = `${apiActWxauth.protocol}//${apiActWxauth.domain}${apiActWxauth.action.auth}`;
      request
        .post(url, {
          appId: apiActWxauth.appid,
          callbackUrl: location.href,
          needPayment: 1,
          // webUserAuthType: to.meta.requiresAuth,
          webUserAuthType: 2,
          forcePopup: true,
          forceSnapShot: true,
        })
        .then(function (res) {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  }

  getUserInfo(openid) {
    // 获取当前用户信息
    return new Promise((resolve, reject) => {
      let url = `${apiActWxauth.protocol}//${apiActWxauth.domain}${apiActWxauth.action.getUserInfo}/${openid}`;
      request
        .get(url, {})
        .then(function (res) {
          let temp = res.data.data;
          if (temp) {
            // window._paq.push(['setUserId',temp.nickName+'_'+temp.openId+'_'+temp.province+'_'+temp.city])
          }
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  }

  getWxWorkAuth(to) {
    return new Promise((resolve, reject) => {
      // 获取授权链接
      let query = {
        htmlUrl: location.href,
        appId: apiActWxauth.appid,
      };
      //在获取微信OAuth2.0授权之前，将活动的appid写入缓存
      if (query.appId) {
        util.cookie.set("actAppId", query.appId, { expires: 30 });
      }
      let url = `${process.env.VUE_APP_WXWORK_API}${apiActWxauth.action.wxWorkauth}`;
      // 1静默授权 2用户授权  0无需授权
      request
        .get(url, {
          scope: to.meta.requiresAuth == 2 ? "snsapi_privateinfo" : "snsapi_userinfo",
          h5CallBackUrl: encodeURIComponent(location.href),
          corpId: Vue.prototype.$corpid,
          appMark: "crm",
        })
        .then(function (res) {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  }

  getWxWorkUserInfo(corpId, account) {
    // 获取当前用户信息
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_WXWORK_API}${apiActWxauth.action.wxWorkGetUserInfo}`;
      request
        .get(url, {
          appid: apiActWxauth.appid,
          corpId: corpId,
          account: account,
          // userId: info.userId,
          accountType: "qywx",
        })
        .then(function (res) {
          let temp = res.data.data;
          if (temp) {
            // window._paq.push(['setUserId',temp.nickName+'_'+temp.openId+'_'+temp.province+'_'+temp.city])
          }
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  }

  async initActInfo() {
    let sortModuleList = [
      { id: '1', value: '奖品展示', type: 'prize' },
      { id: '2', value: '排行奖品', type: 'ranking' },
      { id: '3', value: '优惠券', type: 'coupon' },
      { id: '4', value: '自定义模块', type: 'custom' },
      { id: '5', value: '项目展示', type: 'project' },
      { id: '6', value: '企微二维码', type: 'WxWork' },
    ]
    if (window.location.pathname.indexOf('lightup') > -1) {
      sortModuleList = [
        { id: '1', value: '奖品展示', type: 'prize' },
        { id: '2', value: '排行奖品', type: 'ranking' },
        { id: '3', value: '优惠券', type: 'coupon' },
        { id: '7', value: '奖金池', type: 'prizePool' },
        { id: '4', value: '自定义模块', type: 'custom' },
        { id: '5', value: '项目展示', type: 'project' },
        { id: '6', value: '企微二维码', type: 'WxWork' },
      ]
    }
    const pageData = {
      sortModuleList: sortModuleList,
      defaultSortModuleList: sortModuleList,
      sortModuleSwitch: 0,
    }
    return new Promise(async (resolve, reject) => {
      let url = apizt.action.getConfig;
      const { data, result } = await httpzt.requestRestFul(url, {});
      const uiExt = JSON.parse(data.uiExt);
      if (uiExt["uiExt"]) {
        uiExt.uiExt = JSON.parse(uiExt["uiExt"]);
      } else {
        uiExt.uiExt = {};
      }
      if (result) {
        let configInfo = {
          ...data,
          uiExt: "",
          ...uiExt,
          sortModuleSwitch: uiExt.sortModuleSwitch || pageData.sortModuleSwitch,
          defaultSortModuleList: uiExt.defaultSortModuleList || pageData.defaultSortModuleList,
          sortModuleList: uiExt.sortModuleList || pageData.sortModuleList,
        };
        resolve(configInfo);
      }
      reject(data);
    });
  }

  isWxWork() {
    const configInfo = Vue.prototype.$configInfo;
    console.log(configInfo);
    console.log(Vue.prototype.$errorCode);
    if (Vue.prototype.$errorCode && Vue.prototype.$errorCode != 0) {
      util.cookie.remove("corpId");
      util.cookie.remove("userId");
      return false;
    }
    const corpId = Vue.prototype.$corpId;
    const userId = Vue.prototype.$userId;
    return util.browser.versions.wxwork
    return (util.browser.versions.wxwork && configInfo && configInfo.wxWorkSwitch == 1 && (configInfo.corpid || Vue.prototype.$corpid)) || (corpId && userId);
  }

  wxWorkAuth(to) {
    return new Promise((resolve, reject) => {
      if (this.checkAuthCanUse()) {
        if (Vue.prototype.$userInfo) {
          resolve("ok");
        } else {
          this.getWxWorkUserInfo(Vue.prototype.$corpId, Vue.prototype.$userId).then((res) => {
            if (res && res.data && res.data.data) {
              Vue.prototype.$userInfo = res.data.data;
              Vue.prototype.$openid = res.data.data.openid;
              Vue.prototype.$passport = res.data.data.passport;
              util.cookie.set("actOpenId", res.data.data.openid, { expires: 30 });
              util.cookie.set("openid", res.data.data.openid, { expires: 30 });
              util.cookie.set("passport", res.data.data.passport, { expires: 30 });
              resolve("ok");
            } else {
              util.cookie.remove("corpId");
              util.cookie.remove("userId");
              this.wxAuth(to).then((res) => {
                resolve("ok");
              });
            }
          });
        }
      } else {
        console.log(Vue.prototype.$configInfo);
        console.log(util.cookie.get("configInfo"));
        this.getWxWorkAuth(to).then((res) => {
          console.log("res==>", res);
          if (res && res.data && res.data.data) {
            window.location.replace(res.data.data);
          } else {
            alert("授权链接获取失败！");
          }
        });
      }
    });
  }
  wxAuth(to) {
    return new Promise((resolve, reject) => {
      // 判断授权信息是否还能用

      console.log(this.checkAuthCanUse());
      console.log(Vue.prototype.$fcorpId, Vue.prototype.$fuserId);
      if (Vue.prototype.$fcorpId && Vue.prototype.$fuserId) {
        this.getWxWorkUserInfo(Vue.prototype.$fcorpId, Vue.prototype.$fuserId).then((res) => {
          if (res && res.data && res.data.data) {
            // Vue.prototype.$openid=res.data.data.openid
            // Vue.prototype.$passport=res.data.data.passport
            util.cookie.set("openid", res.data.data.openid, { expires: 30 });
            util.cookie.set("passport", res.data.data.passport, { expires: 30 });
          } else {
            util.cookie.remove("corpId");
            util.cookie.remove("userId");
          }
        });
      }
      if (this.checkAuthCanUse()) {
        if (Vue.prototype.$userInfo) {
          resolve("ok");
        } else {
          this.getUserInfo(Vue.prototype.$openid).then((res) => {
            if (res && res.data && res.data.data) {
              Vue.prototype.$userInfo = res.data.data;
              resolve("ok");
            } else {
              localStorage.clear();
              sessionStorage.clear();
              util.cookie.remove("actAppId");
              util.cookie.remove("actOpenId");
              window.location.reload();
            }
          });
        }
      } else {
        this.getAuthUrl(to).then((res) => {
          console.log("res==>", res);
          if (res && res.data && res.data.data) {
            window.location.replace(res.data.data);
          } else {
            alert("授权链接获取失败！");
          }
        });
      }
    });
  }
}
